// redux/user/profilePictures/userProfilePicturesAPI.js
import apiClient from "../../authentication/utils/core/axios";

// ----------------------------- API Calls -----------------------------

// Fetch current profile picture for a user
export const fetch = async (userId) => {
  const response = await apiClient.get(`/users/${userId}/display-picture`);
  return response.data.picture_url;
};


// Create new profile picture (file or alien URL)
export const create = async (userId, fileOrUrl) => {
  const formData = new FormData();

  if (fileOrUrl instanceof File) {
    formData.append("file", fileOrUrl);
  } else if (typeof fileOrUrl === "string") {
    formData.append("picture_url", fileOrUrl);
  } else {
    throw new Error("Expected File or URL string");
  }

  const response = await apiClient.put(`/users/${userId}/display-picture`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.picture_url;
};

// Update existing profile picture (file or alien URL)
export const update = async (userId, fileOrUrl) => {
  const formData = new FormData();

  if (fileOrUrl instanceof File) {
    formData.append("file", fileOrUrl);
  } else if (typeof fileOrUrl === "string") {
    formData.append("picture_url", fileOrUrl);
  } else {
    throw new Error("Expected File or URL string");
  }

  const response = await apiClient.put(`/users/${userId}/display-picture`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.picture_url;
};


// Delete profile picture
export const del = async (userId) => {
  await apiClient.delete(`/users/${userId}/display-picture`);
  return true;
};
